import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';

export default function REPHQCheckTable({rows,Month1,Month2,Month3}) {

const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },
  {
    field: 'repname',
    headerName: 'REPHQ Name',
    width: 160,
    sortable: false,
    align:"left"
  },
  {
    field: 'brand',
    headerName: 'Brand',
    width: 160,
    sortable: false,
    align:"left"
  },
  {
    field: 'm1_unadjusted_budget_value',
    headerName: `UnAdj.Bud V(${Month1})`,
    width: 170,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=parseFloat(params.row.m1_unadjusted_budget_value).toFixed(2)

      return (
        <p title={params.row.m1_unadjusted_budget_value}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm1_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month1})`,
    width: 180,
    sortable: true,

    align:"center"
  },
   {
    field: 'm1_difference',
    headerName: `(${Month1}) Difference`,
    width: 180,
    sortable: true,

    align:"center"
  },
  {
    field: 'm2_adjusted_budget_value',
    headerName:  `UnAdj.Bud V(${Month2})`,
    width: 170,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=parseFloat(params.row.m2_adjusted_budget_value).toFixed(2)

      return (
        <p title={params.row.m2_adjusted_budget_value}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm2_adjusted_budget_value',
    headerName: `Adj.Bud Val(${Month2})`,
    width: 180,
    sortable: true,
    align:"center"
  },
  {
    field: 'm2_difference',
    headerName: `(${Month2}) Difference`,
    width: 180,
    sortable: true,

    align:"center"
  },
  {
    field: 'm3_unadjusted_budget_value',
    headerName:  `UnAdj.Bud V(${Month3})`,
    width: 180,
    sortable: true,
    renderCell: (params, rowId) => {
      const value=parseFloat(params.row.m3_unadjusted_budget_value).toFixed(2)

      return (
        <p title={params.row.m3_unadjusted_budget_value}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
   

  },
  {
    field: 'm3_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month3})`,
    width: 180,
    sortable: true,
    align:"center"
  },{
    field: 'm3_difference',
    headerName: `(${Month3}) Difference`,
    width: 180,
    sortable: true,

    align:"center"
  },

  
];


  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1}
        Month2={Month2} 
        Month3={Month3}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        density='compact'
      />
    </div>
  );
}
